<template>
  <table class="derbies-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr class="text-center">
        <th colspan="4">Скачки</th>
        <th colspan="3">Игрок</th>
      </tr>
      <tr>
        <th>ид</th>
        <th>статус</th>
        <th>начало</th>
        <th>конец</th>
        <th>присоединение</th>
        <th>участник скачек</th>
        <th>заезды</th>
      </tr>
    </thead>
    <tr
      v-for="playerDerby in playerDerbies"
      :key="playerDerby.derby.id"
      :class="getDerbyClass(playerDerby.derby.status)"
    >
      <td>
        <derby-link :derbyId="playerDerby.derby.id" label="скачки" />
      </td>
      <td :class="getStatusClass(playerDerby.derby.status)">
        {{playerDerby.derby.status | statusStr}}
      </td>
      <td>{{getStimeStr(playerDerby.derby)}}</td>
      <td>{{getFtimeStr(playerDerby.derby)}}</td>
      <td>{{ playerDerby.joinTime | getMomentStr }}</td>
      <td>
        <derby-player-link
          :derbyPlayerId="createDerbyPlayerId(playerDerby.derby.id)"
        />
      </td>
      <td class="text-right">
        <router-link :to="{name: 'derby_player_races', params: {playerId: playerId, derbyId: playerDerby.derby.id}}">
          {{playerDerby.raceAmount | getFormattedNumber}}
        </router-link>
      </td>
    </tr>
  </table>
</template>

<script>
import {Derby} from '../../model/race.js';

import { getMomentMinStrOptionalWithDefault } from '../../util.js';
import { isNumberSpecified                  } from '../../util.js';

import DerbyLink       from './DerbyLink.vue';
import DerbyPlayerLink from './DerbyPlayerLink.vue';


export default {
  name: 'PlayerDerbiesTable',

  components: {
    DerbyLink,
    DerbyPlayerLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    playerDerbies: {
      type: Array,
      required: true,
    }
  },

  methods: {
    getDerbyClass(status) {
      return {
        finished: !isNumberSpecified(status) || Derby.isFinished(status)
      };
    },

    getStimeStr(derby) {
      return getMomentMinStrOptionalWithDefault(derby.startAt, '---');
    },

    getFtimeStr(derby) {
      return getMomentMinStrOptionalWithDefault(derby.finishAt, '---');
    },

    getStatusClass(status) {
      return {
        'status-active': Derby.isActive(status),
      };
    },

    createDerbyPlayerId(derbyId) {
      return {
        derbyId: derbyId,
        playerId: this.playerId,
      };
    },
  },

  filters: {
    statusStr(status) {
      if(!isNumberSpecified(status)) {
        return '---';
      }
      return Derby.getStatusName(status);
    },
  },
};
</script>

<style scoped>
.derbies-table {
  width: 1px;
}

.finished {
  color: #dcdcdc;
}

.status-active {
  color: var(--green);
}
</style>